// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;Let them vanish like water that runs away;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;let them wither like trodden grass.<br> </p> </div></div>";
// Exports
module.exports = code;